import type { Pagination } from '@app/types/pagination'

export const DEFAULT_PAGINATION: Pagination = {
  current: 1,
  pageSize: 100
}
